<ejs-dialog
  #modal
  [width]="dialogWidth"
  [height]="dialogHeight"
  [visible]="false"
  [showCloseIcon]="true"
  [isModal]="true"
  (beforeClose)="onClose()"
  allowDragging="true"
  [cssClass]="'custom-base-dialog'">

  <ng-template #footerTemplate>
    <div class="confirm-footer">
      <button
        ejs-button
        class="e-control e-btn e-primary"
        data-ripple="true"
        (click)="okClick()"
        [style.width]="cancelButton ? '48%' : '100%'">
        Ok
      </button>

      <button
        ejs-button
        *ngIf="cancelButton"
        class="e-control e-btn"
        data-ripple="true"
        (click)="close()"
        style="width: 48%;">
        Cancelar
      </button>
    </div>
  </ng-template>

</ejs-dialog>
